const versiculos = {
  "2 Timoteo 3:16":
    "Toda la Escritura es inspirada por Dios, y útil para enseñar, para redargüir, para corregir, para instruir en justicia. (Reina-Valera 1960)",

  "Juan 3:16":
    "Porque de tal manera amó Dios al mundo, que ha dado a su Hijo unigénito, para que todo aquel que en él cree, no se pierda, mas tenga vida eterna. (Reina-Valera 1960)",

  "Josué 1:9":
    "Mira que te mando que te esfuerces y seas valiente; no temas ni desmayes, porque Jehová tu Dios estará contigo dondequiera que vayas. (Reina-Valera 1960)",

  "Filipenses 4:13":
    "Todo lo puedo en Cristo que me fortalece. (Reina-Valera 1960)",

  "Romanos 8:28":
    "Y sabemos que a los que aman a Dios, todas las cosas les ayudan a bien, esto es, a los que conforme a su propósito son llamados. (Reina-Valera 1960)",

  "1 Pedro 2:9":
    "Mas vosotros sois linaje escogido, real sacerdocio, nación santa, pueblo adquirido por Dios, para que anunciéis las virtudes de aquel que os llamó de las tinieblas a su luz admirable. (Reina-Valera 1960)",

  "Mateo 28:18-20":
    "Y Jesús se acercó y les habló diciendo: Toda potestad me es dada en el cielo y en la tierra. Por tanto, id, y haced discípulos a todas las naciones, bautizándolos en el nombre del Padre, y del Hijo, y del Espíritu Santo; enseñándoles que guarden todas las cosas que os he mandado; y he aquí yo estoy con vosotros todos los días, hasta el fin del mundo. Amén. (Reina-Valera 1960)",

  "Marcos 16:15":
    "Y les dijo: Id por todo el mundo y predicad el evangelio a toda criatura.",

  "2 Timoteo 3:17":
    "A fin de que el hombre de Dios sea perfecto, enteramente preparado para toda buena obra.", 

  "1 Corintios 8:6":
    "Para nosotros, sin embargo, solo hay un Dios, el Padre, del cual proceden todas las cosas, y nosotros somos para él; y un Señor, Jesucristo, por medio del cual son todas las cosas, y nosotros por medio de él.",
  
  "Isaías 7:14":
    "Por tanto, el Señor mismo os dará señal: He aquí que la virgen concebirá, y dará a luz un hijo, y llamará su nombre Emanuel.",
    
  "Juan 3:3":
    "Respondió Jesús y le dijo: De cierto, de cierto te digo, que el que no naciere de nuevo, no puede ver el reino de Dios.",
  
  "Hechos 2:38-39":
    "Pedro les dijo: Arrepentíos, y bautícese cada uno de vosotros en el nombre de Jesucristo para perdón de los pecados; y recibiréis el don del Espíritu Santo. Porque para vosotros es la promesa, y para vuestros hijos, y para todos los que están lejos; para cuantos el Señor nuestro Dios llamare.",
  
  "Juan 5:28-29":
    "No os maravilléis de esto; porque vendrá hora cuando todos los que están en los sepulcros oirán su voz; y los que hicieron lo bueno, saldrán a resurrección de vida; mas los que hicieron lo malo, a resurrección de condenación.",
  
  "1 Corintios 1:10":
    "Os ruego, pues, hermanos, por el nombre de nuestro Señor Jesucristo, que habléis todos una misma cosa, y que no haya entre vosotros divisiones, sino que estéis perfectamente unidos en una misma mente y en un mismo parecer."
};

export default versiculos;
